import { Component, HostListener, inject, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AiAssistantAccessService } from '../../services/ai-assistant-access.service';

@Component({
  selector: 'app-ai-assistant-premium-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './ai-assistant-premium-modal.component.html',
  styleUrl: './ai-assistant-premium-modal.component.css',
})
export class AiAssistantPremiumModalComponent {
  readonly access = inject(AiAssistantAccessService);
  private readonly host = inject(ElementRef<HTMLElement>);

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.access.premiumModalOpen()) {
      this.close();
    }
  }

  close(): void {
    this.access.closePremiumModal();
  }

  onBackdropClick(event: MouseEvent): void {
    if (
      (event.target as HTMLElement).classList.contains(
        'premium-modal__backdrop'
      )
    ) {
      this.close();
    }
  }

  onDialogAnimationEnd(): void {
    if (!this.access.premiumModalOpen()) return;
    const btn = this.host.nativeElement.querySelector(
      '.premium-modal__ok'
    ) as HTMLButtonElement | null;
    btn?.focus();
  }
}
